import React from 'react'
import type { usePainterScheduleLayoutStyles } from './usePainterScheduleLayoutStyles'
import PainterUserAvatar from '../PainterUserAvatar'

interface ScheduleHeaderProps {
  userAvatarUrl?: string
  onMenuClick?: () => void
  classes: ReturnType<typeof usePainterScheduleLayoutStyles>
}

export default function ScheduleHeader({ userAvatarUrl, onMenuClick, classes }: ScheduleHeaderProps) {
  return (
    <div className={classes.header}>
      <div className={classes.headerInner}>
        <span className={classes.headerTitle}>Schedule</span>
        <button type="button" className={classes.avatarBtn} onClick={onMenuClick} aria-label="account menu">
          <PainterUserAvatar className={classes.userAvatar} userAvatarUrl={userAvatarUrl} />
        </button>
      </div>
    </div>
  )
}
